import axios from "axios";

// getImage ถูกเรียกด้วย key เดียวกันจากหลายที่พร้อมกัน (boot, ตารางในหน้า, saleProductCreate)
// เดิมต่างคนต่างยิง ทำให้รูปใบเดียวถูกโหลดซ้ำหลายรอบ (เห็นเป็น 304 คู่ๆ ใน Network tab)
// cache ไว้ตลอด session และรวม request ที่กำลังวิ่งอยู่ให้เหลือครั้งเดียว
const imageCache = new Map();
const imageInFlight = new Map();

export const getImage = (imageKey) => {
  if (!imageKey) {
    return Promise.resolve(undefined);
  }
  if (imageCache.has(imageKey)) {
    return Promise.resolve(imageCache.get(imageKey));
  }
  if (imageInFlight.has(imageKey)) {
    return imageInFlight.get(imageKey);
  }
  let config = {
    method: "get",
    url: `${process.env.REACT_APP_API_UPLOAD_URL}/api/getImage?key=${imageKey}`,
    headers: {
      Authorization: `Basic ${process.env.REACT_APP_API_UPLOAD_KEY_AUTH}`,
    },
  };
  const request = axios(config)
    .then(function (response) {
      // ไม่ cache กรณี error เพื่อให้ครั้งหน้ายิงใหม่ได้
      imageCache.set(imageKey, response.data);
      return response.data;
    })
    .catch(function (error) {
      console.log(error);
    })
    .finally(function () {
      imageInFlight.delete(imageKey);
    });
  imageInFlight.set(imageKey, request);
  return request;
};

// เผื่อกรณีอัปโหลดรูปทับ key เดิมแล้วต้องการให้โหลดใหม่
export const clearImageCache = (imageKey) => {
  if (imageKey) {
    imageCache.delete(imageKey);
  } else {
    imageCache.clear();
  }
};
